import { render, staticRenderFns } from "./PreciosParcelas.vue?vue&type=template&id=c57e5fc0"
import script from "./PreciosParcelas.vue?vue&type=script&lang=js"
export * from "./PreciosParcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports